import { render, staticRenderFns } from "./ToContent.vue?vue&type=template&id=a7804a36&"
import script from "./ToContent.vue?vue&type=script&lang=js&"
export * from "./ToContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports